import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Ng2SmartTableModule } from 'ng2-smart-table';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CollegeDetailsRoutingModule } from './college-details-routing.module';

import { CollegeCourseComponent } from './college-courses/college-courses-add.component';

import { CollegeFacilityComponent } from './college-facility/college-facility-add.component';

import { CollegeVideosComponent } from './college-videos/college-videos-add.component';


import { CollegeOtherComponent } from './college-other/college-other-add.component';

import { CollegeInfoCreateComponent } from './college-info/college-info-create/college-info-create.component';

import { CollegeFormCreateComponent } from './college-form/college-form-create/college-form-create.component';

import { CollegeRankingCreateComponent } from './college-ranking/college-ranking-create/college-ranking-create.component';

import { CollegeApplicationCreateComponent } from './college-application/college-application-create/college-application-create.component';

import { CollegeContactCreateComponent } from './college-contact/college-contact-create/college-contact-create.component';

import { CollegeUniversityCreateComponent } from './college-university/college-university-create/college-university-create.component';

import { CollegeGalleryCreateComponent } from './college-gallery/college-gallery-create/college-gallery-create.component';

import { CollegeScholarshipCreateComponent } from './college-scholarship/college-scholarship-create/college-scholarship-create.component';

import { CollegePlacementCreateComponent } from './college-placement/college-placement-create/college-placement-create.component';

import { CollegeAddressCreateComponent } from './college-address/college-address-create/college-address-create.component';

import { CollegeDocumentCreateComponent } from './college-document/college-document-create/college-document-create.component';

import { CollegeAccreditationCreateComponent } from './college-accreditation/college-accreditation-create/college-accreditation-create.component';

import { CollegeReviewsCreateComponent } from './college-reviews/college-reviews-create/college-reviews-create.component';

import { CollegeNewsCreateComponent } from './college-news/college-news-create/college-news-create.component';

import { CollegeEntranceexamCreateComponent } from './college-entranceexam/college-entranceexam-create/college-entranceexam-create.component';

import { CollegeInfoDetailsCreateComponent } from './college-info-details/college-info-details-create/college-info-details-create.component';

import { CollegeBranchDetailsCreateComponent } from './college-branch-details/college-branch-details-create/college-branch-details-create.component';

import { CollegeCourseDetailsCreateComponent } from './college-course-details/college-course-details-create/college-course-details-create.component';

import { CollegeInfoListComponent } from './college-info/college-info-list/college-info-list.component';

import { CollegeFormListComponent } from './college-form/college-form-list/college-form-list.component';

import { CollegeDocumentListComponent } from './college-document/college-document-list/college-document-list.component';

import { CollegeEntranceexamListComponent } from './college-entranceexam/college-entranceexam-list/college-entranceexam-list.component';

import { CollegeRankingListComponent } from './college-ranking/college-ranking-list/college-ranking-list.component';

import { CollegeUniversityListComponent } from './college-university/college-university-list/college-university-list.component';

import { CollegeGalleryListComponent } from './college-gallery/college-gallery-list/college-gallery-list.component';

import { CollegeScholarshipListComponent } from './college-scholarship/college-scholarship-list/college-scholarship-list.component';

import { CollegePlacementListComponent } from './college-placement/college-placement-list/college-placement-list.component';

import { CollegeAddressListComponent } from './college-address/college-address-list/college-address-list.component';

import { CollegeAccreditationListComponent } from './college-accreditation/college-accreditation-list/college-accreditation-list.component';

import { CollegeApplicationListComponent } from './college-application/college-application-list/college-application-list.component';

import { CollegeReviewsListComponent } from './college-reviews/college-reviews-list/college-reviews-list.component';

import { CollegeNewsListComponent } from './college-news/college-news-list/college-news-list.component';

import { CollegeContactListComponent } from './college-contact/college-contact-list/college-contact-list.component';

import { CollegeInfoDetailsListComponent } from './college-info-details/college-info-details-list/college-info-details-list.component';

import { CollegeBranchDetailsListComponent } from './college-branch-details/college-branch-details-list/college-branch-details-list.component';

import { CollegeCourseDetailsListComponent } from './college-course-details/college-course-details-list/college-course-details-list.component';

import { LogoComponent } from './logo/logo.component';
import { CollegeFormNavbarComponent } from './college-form/college-form-navbar/college-form-navbar.component';

import { GalleryModule } from '@ks89/angular-modal-gallery';
import 'hammerjs';
import 'mousetrap';

import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { CollegeApplicationViewComponent } from './college-application/college-application-view/college-application-view.component';
import { CollegeApplicationComponent } from './college-application/college-view-application/college-application.component';
import { CollegeApprovalListComponent } from './college-form/waiting-for-approval/college-approval-list.component';
import { CollegeModalComponent } from './college-form/modal/college-modal.component';
import { EditorModule,TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  maxFilesize: 50,
  url: 'https://httpbin.org/post',
};



@NgModule({
  declarations: [
    CollegeCourseComponent,
    CollegeFacilityComponent,
    CollegeVideosComponent,
    CollegeOtherComponent,
    CollegeInfoCreateComponent,
    CollegeContactCreateComponent,
    CollegeInfoListComponent,
    CollegeContactListComponent,
    LogoComponent,
    CollegeInfoDetailsCreateComponent,
    CollegeInfoDetailsListComponent,
    CollegeFormNavbarComponent,
    CollegeBranchDetailsCreateComponent,
    CollegeBranchDetailsListComponent,
    CollegeApplicationCreateComponent,
    CollegeApplicationListComponent,
    CollegeApplicationComponent,
    CollegeRankingCreateComponent,
    CollegeRankingListComponent,
    CollegeUniversityCreateComponent,
    CollegeUniversityListComponent,
    CollegeAddressCreateComponent,
    CollegeAddressListComponent,
    CollegeAccreditationCreateComponent,
    CollegeAccreditationListComponent,
    CollegeEntranceexamCreateComponent,
    CollegeEntranceexamListComponent,
    CollegeDocumentCreateComponent,
    CollegeDocumentListComponent,
    CollegeGalleryCreateComponent,
    CollegeGalleryListComponent,
    CollegeFormCreateComponent,
    CollegeFormListComponent,
    CollegePlacementCreateComponent,
    CollegePlacementListComponent,
    CollegeCourseDetailsCreateComponent,
    CollegeCourseDetailsListComponent,
    CollegeScholarshipCreateComponent,
    CollegeScholarshipListComponent,
    CollegeReviewsCreateComponent,
    CollegeReviewsListComponent,
    CollegeNewsCreateComponent,
    CollegeNewsListComponent,
    CollegeApprovalListComponent,
    CollegeApplicationViewComponent,
    CollegeModalComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    CollegeDetailsRoutingModule,
    Ng2SmartTableModule,
    NgbModule,
    DropzoneModule,
    GalleryModule.forRoot()
  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
   {provide:TINYMCE_SCRIPT_SRC, useValue:'/assets/tinymce/tinymce.min.js'},
    NgbActiveModal
  ]
})
export class CollegeDetailsModule { }
